import { getRESTParams, postRESTParams, REMBLE_API_URL } from '.'

const BASE_PATH = `${REMBLE_API_URL}/users/checkin`


const getTodayUserCheckin = async () => {
  const url = `${BASE_PATH}/today`

  const response = await fetch(url, getRESTParams({}))
    .then(response => response.json())
    .catch(error => {
      console.error('error', error)
      return { error }
    })

    return response
}

const getSummaryUserCheckin = async () => {
  const url = `${BASE_PATH}/summary`

  const response = await fetch(url, getRESTParams({}))
    .then(response => response.json())
    .catch(error => {
      console.error('error', error)
      return { error }
    })

    return response
}

const saveUserCheckin = async (payload) => {
  const url = `${BASE_PATH}/create`

  const body = JSON.stringify(payload)

  const saved = await fetch(
    url,
    postRESTParams(
      { body },
      { 'Content-Type': 'application/json' })
    ).catch(error => {
      console.error('error', error)
      return { error }
  })

  return saved
}

export {
  getTodayUserCheckin,
  getSummaryUserCheckin,
  saveUserCheckin
}
